/* eslint-disable react/sort-comp */
/* eslint-disable no-mixed-spaces-and-tabs */
import { h, Component } from 'preact';
import style from './style';

import Bridge from './../bridge';
import * as Helper from '../../helper';

export default class Player extends Component {
	constructor(props) {
		super(props);
		this.origin = window.location.hostname === 'localhost' ? `${Helper.config.DOMAIN}/videos/share/v2` : window.location.origin;
		const { bucketID, videoUUID } = Helper.getVideoID();
		this.pathname = `/${bucketID}${videoUUID}`;

		if (typeof wootag_video_id !== 'undefined') {
			let href = window.location.href;
			let patterns = href.match(/((http|https):\/\/)?(([\w.-]*)\.([\w]*))\/project\/preview\/([A-Za-z0-9]{6}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4})\/([A-Za-z0-9]{4})/);
      
			if (patterns && patterns[6]) {
				this.pathname = `/${patterns[6]}${wootag_video_id}`;
			}
		}
		const urlParams = Helper.getUrlParams() || {};
		let paramsToPass = '';
		Object.keys(urlParams).forEach((key, idx) => {
			if (key) {
				paramsToPass+=`&${key}=${urlParams[key]}`;
			}
		});
		this.url = window.location.hostname === 'localhost' ? `${this.origin}${this.pathname}?previewlink=1${paramsToPass}` : `${this.origin}/videos/share/v2${this.pathname}?previewlink=1${paramsToPass}`;
	}

	componentDidMount() {
		this.bridge = new Bridge(this.iframe);
	}

	componentWillReceiveProps(nextProps) {
		if ((nextProps.mode && this.props.mode !== nextProps.mode) || (nextProps.playerReady && nextProps.playerReady !== this.props.playerReady)) {
			if (nextProps.mode === 1) {
				this.callBridge('forceDesktopEmulation');
			}
			else {
				this.callBridge('forceMobileEmulation');
			}
		}
	}

	render(props, state) {
		const { availableModes, aspectRatio } = props;
		const modesLength = availableModes && availableModes.length;
		const paddingTop = aspectRatio * 100;
		const maxWidth = paddingTop > 75 ? '600px' : '100%';
		return (
			<div class={`player-area-wrapper mode-${props.mode} ${props.hideControls ? 'hideControls' : ''}`}>
				<div class="maxWidthSetter" style={{ width: '100%', maxWidth }}>
					<div class={'player-container'} style={props.mode === 1 ? { paddingTop: `${paddingTop}%` } : {}}>
						<div class={'embed-wrapper'}>
							<div class={'dummy-lines thick'}>
								<div class={'dummy-line wide'} />
								<div class={'dummy-line narrow'} />
							</div>

							<div class={'player-cover'} style={props.mode === 3 ? { paddingTop: `${paddingTop}%` } : {}}>
								<iframe ref={c => this.iframe = c} allowFullScreen src={this.url} />
							</div>

							<div class={'dummy-lines thin'}>
								<div class={'dummy-line full'} />
								<div class={'dummy-line full'} />
								<div class={'dummy-line full'} />
								<div class={'dummy-line full'} />
								<div class={'dummy-line full'} />
								<div class={'dummy-line full'} />
								<div class={'dummy-line full'} />
								<div class={'dummy-line narrow'} />
							</div>
						</div>
					</div>
				</div>
				{modesLength > 1 && <div class={'arrow back'} onClick={this.handleSlider.bind(this, 'back')} />}
				{modesLength > 1 && <div class={'arrow next'} onClick={this.handleSlider.bind(this, 'next')} />}
			</div>
		);
	}

  handleSlider = (direction) => {
  	const mode = this.props.checkModeAvailability(this.props.mode, direction);
  	this.props.modeSelector(mode);
  }

  callBridge = (api, data, cb) => {
  	if (this.bridge && this.bridge.postMessage) {
  		return this.bridge.postMessage({
  			api,
  			data,
  			ctx: this,
  			cb
  		});
  	}
  }
}
 


// WEBPACK FOOTER //
// ./components/player/index.js